import "./bootstrap";
import "@vuepic/vue-datepicker/dist/main.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import "@fortawesome/fontawesome-free/css/brands.min.css";
import "../css/app.scss";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/vue.m";
import { Settings } from "luxon";
import { i18nVue } from "laravel-vue-i18n";
import * as Sentry from "@sentry/vue";
import { withChunkReload } from "./Helpers/chunkReload";

const appName = import.meta.env.VITE_APP_NAME || "The Nerd Hut";

Settings.defaultZone = "utc";

import.meta.glob(["../images/**"]);
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: withChunkReload((name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob("./Pages/**/*.vue"))),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            environment: import.meta.env.VITE_APP_ENV,
            integrations: [Sentry.replayIntegration()],
            // Session Replay
            replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });

        app.use(plugin)
            .use(ZiggyVue)
            .use(i18nVue, {
                resolve: async (lang) => {
                    const langs = import.meta.glob("../../lang/*.json");
                    return await langs[`../../lang/${lang}.json`]();
                },
            })
            .mount(el);
    },
    progress: {
        color: "#ed6d05",
    },
}).then((r) => {});
